import "./Title.scss";
import { Link } from "react-router-dom";

const Title = (props) => {
  return (
    <div className="titleWrapper__ ">
      <div className="titlePrent__">
        <h3>{props.englishTitle}</h3>
        <a className="title__box">
          {props.title}
        </a>
      </div>
      {props.showAll === "true" && (
        <Link to={"/"} className="viewAll_link">
          مشاهده همه
        </Link>
      )}
    </div>
  );
};

export default Title;
